// Se puede sobrescribir en build: REACT_APP_API=https://staging... npm run build
export const API = process.env.REACT_APP_API || 'https://tlalli.systemapp.net';

export const C = {
  bg:          '#0f0a08',
  bgCard:      '#1a1008',
  bgModal:     '#130c06',
  bgHeader:    'rgba(15,10,8,0.97)',
  accent:      '#c9714a',
  accentSoft:  '#e8956d',
  accentDim:   'rgba(201,113,74,0.15)',
  accentBorder:'rgba(201,113,74,0.35)',
  text:        '#f0e6d8',
  textMuted:   '#9c8878',
  textDim:     '#5c4a3c',
  border:      'rgba(201,113,74,0.15)',
  cardHover:   '#221408',
  danger:      '#c0392b',
  dangerDim:   'rgba(192,57,43,0.15)',
  success:     '#27ae60',
  successDim:  'rgba(39,174,96,0.15)',
  gold:        '#f0c040',
  online:      '#2ecc71',
  onlineDim:   'rgba(46,204,113,0.15)',
  tmdb:        '#5dade2',
  tmdbDim:     'rgba(93,173,226,0.15)',
  tmdbBorder:  'rgba(93,173,226,0.35)',
};

export const GENRES = ['Acción','Aventura','Animación','Comedia','Drama','Terror','Ciencia Ficción','Romance','Documental','Thriller','Fantasía','Familiar'];
export const PRESENCE_INTERVAL = 30000;
export const CHUNK_SIZE        = 16 * 1024 * 1024;
export const UPLOAD_PARALLEL   = 4; // chunks subiendo a la vez
